import { Helmet } from 'react-helmet-async';
import AppBarWithLogo from '../components/AppBarWithLogo';
import BottomNav from '../components/BottomNav';
import { Box, Typography } from '@mui/material';
import ContactForm from '../components/ContactForm';

const h1Style = {
    fontSize: {
        xs: '24px',
        sm: '32px',
        md: '60px',
    },
    fontFamily: 'Signika',
    color: 'primary.main',
    lineHeight: {
        xs: 1,
        md: 1.5,
    },
};

const paragraphStyle = {
    fontFamily: 'DM Sans',
    fontSize: {
        xs: '14px',
        sm: '18px',
        md: '20px',
    },
    lineHeight: 1.8,
};

// const textParts = [
//     { text: ' >> ', style: { fontSize:180, fontFamily:"Signika",color: 'primary.main' } },
//     { text: 'Bit Blossom Software', style: {fontSize:180, fontFamily:"Signika", color: 'secondary.main', Opacity:0.6 } },
// ];



const Contact: React.FC = () => {
    return (
        <>
            <Helmet>
                <title>Contact Us | Bit Blossom Software</title>
                <meta name="description" content="Bit Blossom Software provides heart-centered professional services around software solutions in Fargo, ND. Empowering businesses with compassionate, tailored technology solutions." />
                <link rel="canonical" href="https://www.bitblossomsoftware.com/contact" />
            </Helmet>
            <AppBarWithLogo
                logoAlt="Bit Blossom Software Logo"
                logoSrc={`BitBlossom_Logo_Hztl_cropped.png`}
                appName="Bit Blossom Software"
                useDark={false}
            />
            <Box sx={{ overflowX: 'hidden' }}>
                {/* Empowering Businesses Section */}
                <Box style={{
                    position: 'relative', overflow: 'visible', width: '100%'
                }}>
                    <Box
                        component="img"
                        src="ContactUsTopBanner.jpg"
                        alt="Contact Us Top Banner"
                        sx={{
                            display: 'block',
                            width: '100%',
                            height: 'auto',
                            maxHeight: '337px',
                            objectFit: 'cover',
                            opacity: 0.15,
                            zIndex: 0,
                        }}
                    />
                    <Box
                        sx={{
                            position: 'absolute',
                            display: 'flex',
                            top: 0,
                            left: 0,
                            width: { xs: '100%', md: '50%' },
                            height: '100%',
                            flexDirection: 'column',
                            mt: { xs: 0, md: 10 },
                            ml: { xs: 2, md: 10 },
                            pt: { xs: 2, md: 0 },
                            color: 'white',
                            minHeight: '500px',
                        }}
                    >
                        <Typography
                            component="p"
                            variant="h1"
                            sx={{
                                textAlign: 'left',
                                mb: 1,
                                ...h1Style
                            }}
                        >
                            Contact
                        </Typography>

                        <Typography
                            component="p"
                            variant="h2"
                            sx={{
                                textAlign: 'left',
                                ...paragraphStyle,
                                color: 'secondary.main',
                                opacity: 0.8,
                            }}
                        >
                            Ready to work together?
                        </Typography>
                    </Box>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: -5,
                        mb: 10,
                    }}
                >
                    <Box
                        component="img"
                        src="ContactUsOwnerPic.jpg"
                        alt="Contact Us Owner Picture"
                        sx={{
                            width: { xs: '100%', md: '35%' },
                            height: 'auto',
                            mb: { xs: 2, md: 0 },
                            zIndex: 1,
                            mr: { xs: 0, md: 5 },
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    />
                    <Box
                        sx={{
                            width: { xs: '100%', md: '45%' },
                            textAlign: { xs: 'center', md: 'left' },
                        }}
                    >
                        <Typography sx={{ fontSize: { xs: 10, md: 20 }, color: 'primary.main', opacity: 0.8, fontFamily: 'DM Sans', mt: 7, textAlign: 'center', fontWeight: 'medium' }}>
                            Whether you have a question, an idea, or a vision you&rsquo;re ready to bring to life, I&rsquo;d love to hear from you. Simply fill out the form below or reach out directly, and I&rsquo;ll get back to you as soon as possible. Together, we can create something truly extraordinary!
                        </Typography>
                        <ContactForm />
                        <Typography sx={{ fontSize: { xs: 10, md: 20 }, color: 'primary.main', opacity: 0.8, fontFamily: 'DM Sans', mt: 4, textAlign: 'center', fontWeight: 'medium' }}>
                            If you prefer, email me directly at:
                        </Typography>
                        <Typography sx={{ fontSize: { xs: 15, md: 28 }, color: 'secondary.main', opacity: 1.0, fontFamily: 'DM Sans', mt: 0, textAlign: 'center', fontWeight: 'medium' }}>
                            Hello@BitBlossomSoftware.com
                        </Typography>
                    </Box>
                </Box>
                {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',width:'100%' }}>
                    <ScrollingText textParts={textParts}></ScrollingText>
                </Box> */}
                <BottomNav useDark={true} />
            </Box>
        </>
    );
};

export default Contact;